// frontend/src/RouteTracker.tsx

import { useEffect, useState } from 'react';
import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { GA_FUNNEL, isAnalyticsActive, trackEvent, subscribeAnalyticsConsent } from './utils/gaEvents';
import { EVENTS, insight } from './utils/productInsights';
import { parseCrawlLocale } from './utils/localePath';
import { checkoutCancellationForRoute } from './config/productInsights';

const RouteTracker = () => {
  const location = useLocation();
  const landingTrackedRef = useRef(false);
  const [consented, setConsented] = useState(isAnalyticsActive);
  const routeRef = useRef('');
  useEffect(() => subscribeAnalyticsConsent(() => {
    setConsented(isAnalyticsActive());
    if (!isAnalyticsActive()) routeRef.current = '';
  }), []);

  useEffect(() => {
    // Consent module flag — not ReactGA.isInitialized (stays true after decline).
    if (isAnalyticsActive() && routeRef.current !== location.key) {
      routeRef.current = location.key;
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
      const logicalPath = parseCrawlLocale(location.pathname).path;
      if (logicalPath === '/pricing') {
        insight(EVENTS.PRICING_VIEW);
      }
      const cancellation = checkoutCancellationForRoute(logicalPath, location.search);
      if (cancellation) {
        insight(EVENTS.CHECKOUT_CANCELLED, cancellation);
      }

      if (!landingTrackedRef.current) {
        landingTrackedRef.current = true;
        const search = new URLSearchParams(location.search || '');
        const refHost = (() => {
          try {
            return document.referrer ? new URL(document.referrer).hostname : undefined;
          } catch {
            return undefined;
          }
        })();
        trackEvent(GA_FUNNEL.TRAFFIC_LANDING, {
          landing_path: location.pathname,
          utm_source: search.get('utm_source') || undefined,
          utm_medium: search.get('utm_medium') || undefined,
          utm_campaign: search.get('utm_campaign') || undefined,
          utm_term: search.get('utm_term') || undefined,
          utm_content: search.get('utm_content') || undefined,
          gclid: search.get('gclid') || undefined,
          gbraid: search.get('gbraid') || undefined,
          wbraid: search.get('wbraid') || undefined,
          referrer_host: refHost,
        });
      }
    }
  }, [location, consented]);

  return null;
};

export default RouteTracker;
